import { EventBus } from "../../../eventbus";
import VueCircle from "vue2-circle-progress";
import filesize from "filesize";
import { baseUrl } from "../../../config.js";
import i18n from "../../../functions/i18next";
import { upload } from "../../../functions/Upload";

var timeoutHandle;

export default {
  props: {
    itemData: Object,
  },

  components: { VueCircle },
  data() {
    return {
      user: this.$store.state.user,
      company: this.$store.state.company,
      files: [],
      show: false,
      uploadPercentage: 1,
      step: 1,
      folder: 0,
      uploadComplete: false,
      dragAndDropCapable: false,
      errors: [],
      tags: [],
      newtag: "",
      canAdd: null,
      submitted: false,
      tagsuggestions: [],
      options: false,
    };
  },

  computed: {
    spaceRemaining: function () {
      let used = 0;
      for (var i = 0; i < this.files.length; i++) {
        used += this.files[i].size;
      }
      let diff = 2147483648 - used;
      diff = filesize(diff).toString().toLowerCase().replace(/\s/g, "");
      return diff;
    },
  },

  methods: {
    formatSize(key) {
      let size = this.files[key].size;
      size = filesize(size).toString().toLowerCase().replace(/\s/g, "");
      return size;
    },
    fileName(key, ext) {
      let file = this.files[key];
      let extention =
        "." + file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2);
      if (ext) {
        return extention;
      }
      return file.name.replace(extention, "");
    },
    addFiles() {
      this.$refs.files.click();
    },
    preventDefault(e) {
      e.preventDefault();
    },
    saveFiles(e = false) {
      if (e) {
        e.preventDefault();
      }

      upload(
        {
          folderId: this.itemData.folderId,
          files: this.files,
          myspace: this.itemData.myspace,
          tags: JSON.stringify(this.tags),
        },
        this
      );

      //get new files
      EventBus.$emit(`closeallactions`);
    },
    /*s
         Determines if the drag and drop functionality is in the window
       */
    determineDragAndDropCapable() {
      var div = document.createElement("div");
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },

    transitionHandler() {
      //this.submitFiles();
    },

    /*
          Handles a change on the file upload
        */
    handleFilesUpload() {
      this.filesUpload(this.$refs.files.files);
    },
    filesUpload(recieved) {
      let self = this;
      let err_filecount = false;
      let err_fileduplicate = false;
      let err_filesize = false;
      this.errors = [];
      let totalsize = 0;

      for (let i = 0; i < recieved.length; i++) {
        let file = recieved[i];
        if (this.files.length < 200) {
          if (
            !(
              this.files.filter(function (e) {
                return e.name === file.name;
              }).length > 0
            )
          ) {
            totalsize += file.size;
            if (totalsize <= 4000000000) {
              this.files.push(file);
            } else {
              err_filesize = true;
            }
          } else {
            //err_fileduplicate = true;
          }
        } else {
          err_filecount = true;
        }
      }
      /*if (err_fileduplicate) {
        this.errors.push(
          "Uh-oh. Looks like you're trying to upload the same file twice."
        );
      }*/
      if (err_filecount) {
        this.errors.push(i18n.t("upload.upload_count_limit"));
      }
      if (err_filesize) {
        this.errors.push(i18n.t("upload.upload_size_limit", { size: "2GB" }));
      }
      if (err_fileduplicate || err_filecount || err_filesize) {
        timeoutHandle = window.setTimeout(function () {
          self.errors = [];
        }, 7500);
      } else {
        window.clearTimeout(timeoutHandle);

        //no errors so clear the drop box of files
        this.$refs.files.value = null;
      }
    },
    /*
          Removes a select file the user has uploaded
        */
    removeFile(key) {
      var filelist = Array.from(this.files);
      filelist.splice(key, 1);
      this.files = filelist;
    },
    close() {
      this.show = false;

      EventBus.$emit("openfolder", this.folder);
    },
    addTag() {
      if (this.tags.indexOf(this.newtag) <= -1) {
        this.tags.push(this.newtag);
        this.newtag = "";
        this.canAdd = false;
      }
    },
    deleteTag(key) {
      this.tags.splice(key, 1);
    },
    loadTagSuggestions() {
      this.$axios
        .get(baseUrl + "/tagcomplete?q=" + this.newtag, {
          responseType: "json",
        })
        .then((response) => {
          this.tagsuggestions = [];
          for (var i = 0; i < response.data.length; i++) {
            this.tagsuggestions.push(response.data[i].tag);
          }

          if (this.tagsuggestions.length > 0) {
            this.options = true;
          } else {
            this.options = false;
          }
        });
    },
    fillSuggestion(event) {
      this.newtag = event.target.innerHTML;
      this.tagsuggestions = [];
      this.options = false;
    },
  },
  mounted() {
    if (this.itemData.files && this.$refs.files) {
      const allFiles = Array.from(this.$refs.files.files).concat(
        Array.from(this.itemData.files)
      );
      this.$refs.files.files = this.itemData.files;

      //add these files and upload them all
      this.handleFilesUpload();
      this.saveFiles();
    }

    this.dragAndDropCapable = this.determineDragAndDropCapable();

    /*
        If drag and drop capable, then we continue to bind events to our elements.
        */
    if (this.dragAndDropCapable && this.$refs.fileform) {
      /*
            Listen to all of the drag events and bind an event listener to each
            for the fileform.
            */
      [
        "drag",
        "dragstart",
        "dragend",
        "dragover",
        "dragenter",
        "dragleave",
        "drop",
      ].forEach(
        function (evt) {
          /*
                For each event add an event listener that prevents the default action
                (opening the file in the browser) and stop the propagation of the event (so
                no other elements open the file in the browser)
                */
          this.$refs.fileform.addEventListener(
            evt,
            function (e) {
              e.preventDefault();
              e.stopPropagation();
            }.bind(this),
            false
          );
        }.bind(this)
      );

      /*
            Add an event listener for drop to the form
            */
      this.$refs.fileform.addEventListener(
        "drop",
        function (e) {
          this.filesUpload(e.dataTransfer.files);
        }.bind(this)
      );
    }
  },
  updated() {
    this.dragAndDropCapable = this.determineDragAndDropCapable();

    /*
        If drag and drop capable, then we continue to bind events to our elements.
        */
    if (this.dragAndDropCapable && this.$refs.fileform) {
      /*
            Listen to all of the drag events and bind an event listener to each
            for the fileform.
            */
      [
        "drag",
        "dragstart",
        "dragend",
        "dragover",
        "dragenter",
        "dragleave",
        "drop",
      ].forEach(
        function (evt) {
          /*
                For each event add an event listener that prevents the default action
                (opening the file in the browser) and stop the propagation of the event (so
                no other elements open the file in the browser)
                */
          this.$refs.fileform.addEventListener(
            evt,
            function (e) {
              e.preventDefault();
              e.stopPropagation();
            }.bind(this),
            false
          );
        }.bind(this)
      );

      /*
            Add an event listener for drop to the form
            */
      this.$refs.fileform.addEventListener(
        "drop",
        function (e) {
          this.filesUpload(e.dataTransfer.files);
        }.bind(this)
      );
    }
  },
};
